import { type BreadcrumbItem } from "../NavigationBreadcrumbs";

export const UPDATE_NAVIGATIONBREADCRUMS = "NavigationBreadcrumbs: Update navigationBreadcrumbs";

export function updateNavigationBreadcrumbs(breadcrumbs: BreadcrumbItem[]) {
  return {
    type: UPDATE_NAVIGATIONBREADCRUMS,
    payload: {
      breadcrumbs,
    },
  };
}
 